<template>
    <footer
        class="DefaultFooter"
        :class="{ 'IndustryFooter' : reverse }"
    >
        <figure
            :data-bgset="image"
            class="DefaultFooter__image lazyload"
        />
        <div class="container flex-vertical-b z-index relative">
            <div class="IndustryFooterColumns">
                <div class="IndustryFooter__column pt-none">
                    <IndustryLogo />
                </div>
                <div class="IndustryFooter__column">
                    <div class="IndustryFooter__list">
                        <h4>Quick Links</h4>
                        <ul>
                            <li
                                v-for="item in quickLinks"
                                :key="item.id"
                            >
                                <a :href="addSlash(item.uri)">
                                    {{ item.title }}
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="IndustryFooter__column">
                    <h4>Contact</h4>
                    <dl class="IndustryFooter__details">
                        <div
                            v-for="item in details"
                            :key="item.id"
                        >
                            <dt>{{ item.label }}</dt>
                            <dd v-html="item.text"></dd>
                        </div>
                    </dl>
                    <SocialLinks
                        :items="social"
                        classes="IndustryFooter__SocialLinks"
                        :color="socialColor()"
                    />
                </div>
            </div>
            <p
                class="IndustryFooter__text sub mb-medium pr-medium"
                :class="{ 'text--white' : reverseAcknowledgement }"
            >
                {{ text }}
            </p>
        </div>
    </footer>
</template>
<script>

import SocialLinks from './SocialLinks.vue'

export default {
    name: 'IndustryFooter',
    components: {
        SocialLinks
    },
    props: {
        text: {
            type: String,
            default: null
        },
        image: {
            type: String,
            default: null
        },
        heading: {
            type: String,
            default: null
        },
        quickLinks: {
            type: Array,
            default: null
        },
        social: {
            type: Array,
            default: null
        },
        details: {
            type: Array,
            default: null
        },
        reverse: {
            type: Boolean,
            default: false
        },
        reverseAcknowledgement: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        address() {
            return this.$attrs.address[0]
        }
    },
    methods: {
        addSlash(link) {
            return `/${link}`;
        },
        socialColor() {
            return this.reverse ? '#fff' : '#000'
        }
    }
}
</script>
<style lang="scss" scoped>
    .DefaultFooter {
        color: #000;
        --border-colour: rgba(80,92,99,0.4);
    }

    .IndustryFooter {
        background-color: transparent;
        padding-top: getSpacing('large');
        padding-bottom: getSpacing('xlarge');
        color: getColor('white');
        &.DefaultFooter {
            --border-colour: rgba(255,255,255,0.4);
        }
    }

    .IndustryFooterColumns {
        display: flex;
        flex-direction: column;

        @include media-query(desk) {
            flex-direction: row;
        }
    }

    .IndustryLogo {
        height: 90px;
        display: block;
        position: relative;
        top: -15px;

        ::v-deep svg {
            fill: currentColor;
            width: auto;
            height: 100%;

            &.not-stacked {
               display: none;
            }

            &.stacked {
               display: block;
            }
        }

    }

    .IndustryFooter__text {
        margin-top: getSpacing('large');
    }

    .IndustryFooter__list {
        li {
            font-size: 15px;

            &:not(:last-child) {
                margin-bottom: 1.2em;
            }

            @include media-query(smart) {
                font-size: 12px;
            }
        }
    }

    .IndustryFooter__details > div {
        display: flex;
        font-size: 15px;
        margin-bottom: 1.2em;

        dt, dd {
            line-height: 1.4em;
        }

        dt {
            font-weight: bold;
            width: 5rem;
        }
    }

    h4 {
        font-family: $heading-font-family;
        text-transform: uppercase;
        margin-bottom: getSpacing('base');
        font-size: 1rem;

        @include media-query(desk) {
            font-size: 1.1rem;
        }
    }

    .IndustryFooter__column {
        padding-bottom: getSpacing('medium');
        padding-top: getSpacing('medium');

        @include media-query(desk) {
            width: 35%;
            padding-bottom: 0;
            padding-top: 0;
        };

        &:not(:nth-child(1)) {
            @include media-query(desk) {
                padding-left: getSpacing('medium');
            }
        }

        &:not(:last-child) {
            border-bottom: 1px solid var(--border-colour);

            @include media-query(desk) {
                padding-right: getSpacing('medium');
                border-bottom: none;
                border-right: 1px solid var(--border-colour);
            }
        }

        .IndustryFooter__SocialLinks {
            font-size: 1.2rem;
        }
    }

    .IndustryFooter__column--narrow {
        width: 30%;
    }
</style>
